module.exports = __webpack_public_path__ + "static/img/年度最佳SUV.067fd393.png";